import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { isMobile } from 'src/lib/isMobile';

import User from '../../../models/user/user';
import useFetchCurrentUserQuery from './useFetchCurrentUserQuery';
import useIsLoggedIn from '../../../../hooks/useIsLoggedIn';
import Routes from '../../../navigation/routes';
import { getGuestHashFromNavigation, getLandingPagePriceIDFromNavigation } from '../../../lib/urlUtils';

const withGlobalModals = <P extends {currentUser?: User}>( Component : React.ComponentType<P> ) => observer(
	( props : P ) => {
		const [ hasOnboardingBeenShown, setOnboardingBeenShown ] = useState( false );
		const isLoggedIn = useIsLoggedIn();
		const { data: currentUser } = useFetchCurrentUserQuery();
		const history = useHistory();
		const guestHash = getGuestHashFromNavigation();
		const landingPagePriceID = getLandingPagePriceIDFromNavigation();
		useEffect( () => {
			if ( currentUser && !currentUser.missingOnboardingAnswers ) {
				setOnboardingBeenShown( false );
			}
		}, [ currentUser?.missingOnboardingAnswers ] );

		useEffect( () => {
			const shouldRedirectToOnboarding = (
				isLoggedIn
					&& currentUser?.missingOnboardingAnswers
					&& !hasOnboardingBeenShown
					&& !isMobile
					&& history.location.pathname !== Routes.toOnboarding
			);

			if ( shouldRedirectToOnboarding ) {
				const state = {
					...( guestHash && { guestHash } ),
					...( landingPagePriceID !== null && { landingPagePriceID } )
				};
				history.push( Routes.toOnboarding, Object.keys( state ).length > 0 ? state : undefined );
				setOnboardingBeenShown( true );
			}
		}, [ isLoggedIn, currentUser, hasOnboardingBeenShown, history, guestHash, landingPagePriceID ] );

		return <Component {...props} />;
	}
);

export default withGlobalModals;
